import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Modal, Form, Row, Col, InputGroup, Badge, Pagination, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaTrash, FaEdit, FaPlus, FaSearch, FaSortUp, FaSortDown, FaSort } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import Select from 'react-select';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import ModalFamiliaAtivo from './ModalFamiliaAtivo';

const TIPOS_FAMILIA = [
  { value: '0', label: '0 - Moeda a Vista' },
  { value: '1', label: '1 - Moeda a Receber' },
  { value: '2', label: '2 - Difícil Liquidação' },
  { value: '3', label: '3 - Estoque' },
  { value: '4', label: '4 - Investimentos' },
  { value: '5', label: '5 - Imobilizado' },
  { value: '6', label: '6 - Moeda a Pagar' },
  { value: '7', label: '7 - Patrimônio Líquido' },
];

const STATUS_FAMILIA = [
  { value: 'A', label: 'Ativa' },
  { value: 'I', label: 'Inativa' },
];

const ITENS_POR_PAGINA = 20;

const FamiliasAtivos = () => {
  const [familias, setFamilias] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [filtroTipo, setFiltroTipo] = useState(null);
  const [filtroGrupo, setFiltroGrupo] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingAcao, setLoadingAcao] = useState(false);
  const [gruposFamilia, setGruposFamilia] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [familiaEditando, setFamiliaEditando] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [familiaParaExcluir, setFamiliaParaExcluir] = useState(null);

  const [ordenacao, setOrdenacao] = useState({ campo: 'nome', direcao: 'asc' });
  const [pagina, setPagina] = useState(1);

  const thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  const temPermissao = AuthStorage.temCaracteristica(caracteristicas.CriarAlterarFamilia);

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => {
      if (prev.campo === campo) {
        return { campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo, direcao: 'asc' };
    });
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  useEffect(() => {
    carregarGrupos();
    carregarFamilias(null, null, null, null);
  }, []);

  const carregarGrupos = async () => {
    try {
      const res = await api.listarGrupoFamilias();
      setGruposFamilia(res || []);
    } catch (e) {
      // silencia erro de grupos — dropdown ficará vazio
    }
  };

  const carregarFamilias = async (filtroVal, tipoVal, grupoVal, statusVal) => {
    setLoading(true);
    try {
      const f = filtroVal && filtroVal.trim() ? filtroVal.trim() : null;
      const res = await api.listarFamiliasAtivos(f, tipoVal || null, grupoVal || null, statusVal || null);
      setFamilias(res || []);
      setPagina(1);
    } catch (e) {
      toast.error('Erro ao carregar famílias de ativos');
    } finally {
      setLoading(false);
    }
  };

  const handleBuscar = () => {
    carregarFamilias(
      filtro,
      filtroTipo ? filtroTipo.value : null,
      filtroGrupo ? filtroGrupo.value : null,
      filtroStatus ? filtroStatus.value : null
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleBuscar();
    }
  };

  const handleNovaFamilia = () => {
    setFamiliaEditando(null);
    setShowModal(true);
  };

  const handleEditarFamilia = (familia) => {
    setFamiliaEditando(familia);
    setShowModal(true);
  };

  const handleSalvar = () => {
    setShowModal(false);
    carregarFamilias(filtro, filtroTipo ? filtroTipo.value : null, filtroGrupo ? filtroGrupo.value : null, filtroStatus ? filtroStatus.value : null);
  };

  const handleConfirmarExclusao = (familia) => {
    setFamiliaParaExcluir(familia);
    setShowDeleteModal(true);
  };

  const handleExcluir = async () => {
    setLoadingAcao(true);
    try {
      await api.excluirFamiliaAtivo(familiaParaExcluir.codigo);
      toast.success('Família inativada com sucesso!');
      setShowDeleteModal(false);
      setFamiliaParaExcluir(null);
      carregarFamilias(filtro, filtroTipo ? filtroTipo.value : null, filtroGrupo ? filtroGrupo.value : null, filtroStatus ? filtroStatus.value : null);
    } catch (err) {
      const msg = (err && err.message) || 'Erro ao inativar família';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  const getTipoLabel = (tipo) => {
    const tipoObj = TIPOS_FAMILIA.find((t) => t.value === tipo);
    return tipoObj ? tipoObj.label : tipo || '-';
  };

  const familiasOrdenadas = familias.slice().sort((a, b) => {
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    const campo = ordenacao.campo;
    let valA = a[campo];
    let valB = b[campo];
    if (valA == null) valA = campo === 'nome' ? '' : 0;
    if (valB == null) valB = campo === 'nome' ? '' : 0;
    if (campo === 'nome' || campo === 'tipo' || campo === 'grupo' || campo === 'status') {
      return dir * String(valA).toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (Number(valA) - Number(valB));
  });

  const totalPaginas = Math.ceil(familiasOrdenadas.length / ITENS_POR_PAGINA) || 1;
  const dadosPaginados = familiasOrdenadas.slice((pagina - 1) * ITENS_POR_PAGINA, pagina * ITENS_POR_PAGINA);

  const grupoLabel = (familia) => {
    if (!familia.codigo_grupo_familia) return '-';
    return familia.codigo_grupo_familia + (familia.nome_grupo_familia ? ' - ' + familia.nome_grupo_familia : '');
  };

  const renderizarPaginacao = () => {
    if (totalPaginas <= 1) return null;

    const itens = [];
    const maxBotoes = 5;

    itens.push(
      <Pagination.First
        key="first"
        onClick={() => setPagina(1)}
        disabled={pagina === 1}
      />
    );

    itens.push(
      <Pagination.Prev
        key="prev"
        onClick={() => setPagina(pagina - 1)}
        disabled={pagina === 1}
      />
    );

    let inicioPaginas = Math.max(1, pagina - Math.floor(maxBotoes / 2));
    let fimPaginas = Math.min(totalPaginas, inicioPaginas + maxBotoes - 1);

    if (fimPaginas - inicioPaginas < maxBotoes - 1) {
      inicioPaginas = Math.max(1, fimPaginas - maxBotoes + 1);
    }

    if (inicioPaginas > 1) {
      itens.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
    }

    for (let i = inicioPaginas; i <= fimPaginas; i++) {
      itens.push(
        <Pagination.Item
          key={i}
          active={i === pagina}
          onClick={() => setPagina(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (fimPaginas < totalPaginas) {
      itens.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    itens.push(
      <Pagination.Next
        key="next"
        onClick={() => setPagina(pagina + 1)}
        disabled={pagina === totalPaginas}
      />
    );

    itens.push(
      <Pagination.Last
        key="last"
        onClick={() => setPagina(totalPaginas)}
        disabled={pagina === totalPaginas}
      />
    );

    return (
      <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ borderTop: '1px solid #dee2e6' }}>
        <small className="text-muted">
          Mostrando {dadosPaginados.length > 0 ? (pagina - 1) * ITENS_POR_PAGINA + 1 : 0}
          {' até '}{Math.min(pagina * ITENS_POR_PAGINA, familiasOrdenadas.length)}{' de '}{familiasOrdenadas.length}{' registros'}
        </small>
        <Pagination className="mb-0">{itens}</Pagination>
      </div>
    );
  };

  if (loading && familias.length === 0) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .fa-desktop { display: block; }\
        .fa-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .fa-desktop { display: none !important; }\
          .fa-mobile  { display: block; }\
        }\
      '}</style>

      <Header title="Famílias de Ativos" />

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Row className="align-items-end">
            <Col xs={12} md={3} className="mb-2 mb-md-0">
              <Form.Group controlId="filtro.busca" className="mb-0">
                <Form.Label>Busca</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Código ou descrição..."
                  value={filtro}
                  onChange={(e) => setFiltro(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={2} className="mb-2 mb-md-0">
              <Form.Group controlId="filtro.tipo" className="mb-0">
                <Form.Label>Tipo</Form.Label>
                <Select
                  options={TIPOS_FAMILIA}
                  value={filtroTipo}
                  onChange={(op) => setFiltroTipo(op)}
                  placeholder="Todos..."
                  isClearable
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={2} className="mb-2 mb-md-0">
              <Form.Group controlId="filtro.grupo" className="mb-0">
                <Form.Label>Grupo</Form.Label>
                <Select
                  options={gruposFamilia.map((g) => ({ value: g.codigo, label: `${g.codigo} - ${g.nome}` }))}
                  value={filtroGrupo}
                  onChange={(op) => setFiltroGrupo(op)}
                  placeholder="Todos..."
                  isClearable
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={2} className="mb-2 mb-md-0">
              <Form.Group controlId="filtro.status" className="mb-0">
                <Form.Label>Status</Form.Label>
                <Select
                  options={STATUS_FAMILIA}
                  value={filtroStatus}
                  onChange={(op) => setFiltroStatus(op)}
                  placeholder="Todos..."
                  isClearable
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3} className="text-md-right">
              <Form.Group className="d-flex justify-content-end flex-wrap mb-0" style={{ gap: '8px' }}>
                <Button variant="outline-primary" onClick={handleBuscar} disabled={loading}>
                  {loading
                    ? <><Spinner animation="border" size="sm" className="mr-1" />Buscando...</>
                    : <><FaSearch className="mr-1" /> Buscar</>
                  }
                </Button>
                {temPermissao && (
                  <Button variant="primary" onClick={handleNovaFamilia}>
                    <FaPlus className="mr-1" /> Novo
                  </Button>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Famílias de Ativos
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({familiasOrdenadas.length} {familiasOrdenadas.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0" style={{ position: 'relative' }}>
          {loading && familias.length > 0 && (
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 2,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Spinner animation="border" size="sm" className="mr-2" />
              <span className="text-muted">Carregando...</span>
            </div>
          )}
          {loading && familias.length === 0 ? (
            <p className="text-muted text-center my-4">
              <Spinner animation="border" size="sm" className="mr-2" />
              Carregando...
            </p>
          ) : familiasOrdenadas.length === 0 ? (
            <p className="text-muted text-center my-4">
              {filtro || filtroTipo ? 'Nenhuma família encontrada para o filtro informado.' : 'Nenhuma família cadastrada.'}
            </p>
          ) : (
            <>
              <div className="fa-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '80px', ...thSortStyle }} onClick={() => handleOrdenacao('codigo')}>
                        Código{iconeOrdenacao('codigo')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('nome')}>
                        Descrição{iconeOrdenacao('nome')}
                      </th>
                      <th style={{ width: '90px', ...thSortStyle }} onClick={() => handleOrdenacao('taxa_dep')}>
                        Deprec.{iconeOrdenacao('taxa_dep')}
                      </th>
                      <th style={{ width: '110px', ...thSortStyle }} onClick={() => handleOrdenacao('preco_base_padrao')}>
                        P.Base Padrão{iconeOrdenacao('preco_base_padrao')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('tipo')}>
                        Tipo{iconeOrdenacao('tipo')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('codigo_grupo_familia')}>
                        Grupo{iconeOrdenacao('codigo_grupo_familia')}
                      </th>
                      <th style={{ width: '90px', ...thSortStyle }} onClick={() => handleOrdenacao('dias')}>
                        Dias Vencto.{iconeOrdenacao('dias')}
                      </th>
                      <th style={{ width: '80px', ...thSortStyle }} onClick={() => handleOrdenacao('status')}>
                        Status{iconeOrdenacao('status')}
                      </th>
                      {temPermissao && (
                        <th style={{ width: '90px', textAlign: 'center' }}>Ações</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {dadosPaginados.map((familia) => (
                      <tr key={familia.codigo}>
                        <td>{familia.codigo}</td>
                        <td>{familia.nome}</td>
                        <td>{familia.taxa_dep != null ? Number(familia.taxa_dep).toFixed(4) : '-'}</td>
                        <td>{familia.preco_base_padrao != null ? Number(familia.preco_base_padrao).toFixed(4) : '-'}</td>
                        <td>{getTipoLabel(familia.tipo)}</td>
                        <td>{grupoLabel(familia)}</td>
                        <td className="text-center">{familia.dias != null ? familia.dias : '-'}</td>
                        <td className="text-center">
                          <Badge variant={familia.status === 'A' ? 'success' : 'secondary'}>
                            {familia.status === 'A' ? 'Ativa' : 'Inativa'}
                          </Badge>
                        </td>
                        {temPermissao && (
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              title="Editar"
                              className="mr-1"
                              onClick={() => handleEditarFamilia(familia)}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Inativar"
                              onClick={() => handleConfirmarExclusao(familia)}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="fa-mobile p-2">
                {dadosPaginados.map((familia) => (
                  <Card key={familia.codigo} className="mb-2 shadow-sm">
                    <Card.Body className="py-2 px-3">
                      <div className="d-flex justify-content-between align-items-start mb-1">
                        <div>
                          <strong style={{ fontSize: '0.95rem' }}>{familia.nome}</strong>
                          <br />
                          <small className="text-muted">Código: {familia.codigo}</small>
                        </div>
                        <Badge variant={familia.status === 'A' ? 'success' : 'secondary'}>
                          {familia.status === 'A' ? 'Ativa' : 'Inativa'}
                        </Badge>
                      </div>
                      <div style={{ fontSize: '0.85rem' }} className="mb-2">
                        <div><strong>Tipo:</strong> {getTipoLabel(familia.tipo)}</div>
                        <div><strong>Grupo:</strong> {grupoLabel(familia)}</div>
                        <div><strong>Deprec.:</strong> {familia.taxa_dep != null ? Number(familia.taxa_dep).toFixed(4) : '-'}</div>
                        <div><strong>Dias Vencto.:</strong> {familia.dias != null ? familia.dias : '-'}</div>
                      </div>
                      {temPermissao && (
                        <div className="d-flex justify-content-between">
                          <Button size="sm" variant="outline-primary" onClick={() => handleEditarFamilia(familia)}>
                            <FaEdit className="mr-1" /> Editar
                          </Button>
                          <Button size="sm" variant="outline-danger" onClick={() => handleConfirmarExclusao(familia)}>
                            <FaTrash className="mr-1" /> Inativar
                          </Button>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                ))}
              </div>
              {renderizarPaginacao()}
            </>
          )}
        </Card.Body>
      </Card>

      <ModalFamiliaAtivo
        show={showModal}
        onHide={() => setShowModal(false)}
        familia={familiaEditando}
        gruposFamilia={gruposFamilia}
        onSalvar={handleSalvar}
      />

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Inativar Família de Ativo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Deseja realmente inativar a família{' '}
          <strong>
            {familiaParaExcluir ? `${familiaParaExcluir.codigo} - ${familiaParaExcluir.nome}` : ''}
          </strong>?
          <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.875rem' }}>
            O registro será marcado como inativo e não aparecerá nas listagens.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={loadingAcao}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleExcluir} disabled={loadingAcao}>
            {loadingAcao ? 'Inativando...' : 'Inativar'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FamiliasAtivos;
